/**
 * Styles for wf-options component (Shadow DOM)
 *
 * Co-located with the component for better maintainability.
 */

import { css } from 'lit';

export const wfOptionsStyles = css`
  :host {
    display: grid;
    box-sizing: border-box;
  }

  :host([hidden]) {
    display: none;
  }

  /* Width classes inherited from WfLayout */
  :host(.wf-layout--width-full) {
    width: 100%;
  }

  :host(.wf-layout--width-auto) {
    width: auto;
  }

  :host(.wf-layout--width-fit) {
    width: fit-content;
  }

  /* Error wrapper for animated expand/collapse */
  .wf-error-wrapper {
    grid-column: 1 / -1;
    order: 1000;
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 200ms ease-out;
  }

  .wf-error-wrapper.wf-has-error {
    grid-template-rows: 1fr;
  }

  .wf-error-message {
    overflow: hidden;
    min-height: 0;
    font-size: var(--wf-font-size-sm);
    color: var(--wf-color-error);
    opacity: 0;
    transform: translateY(-4px);
    transition: opacity 200ms ease-out, transform 200ms ease-out;
  }

  .wf-has-error .wf-error-message {
    margin-top: var(--wf-spacing-2);
    opacity: 1;
    transform: translateY(0);
  }

  /* Slotted wf-other spans full width and appears after options */
  ::slotted(wf-other) {
    grid-column: 1 / -1;
    order: 999;
  }
`;
